import {AiChatOpenEditorType, GA4EventName, GA4EventParamName} from '@Libraries/ga-events';
import {trackFakeDoorPostUsedIfNeeded} from '@Libraries/marketing-planner.library';

interface UseOpenChatImageInEditor {
  openPosterInEditor: (hashedId: string) => void;
}

export const useOpenChatImageInEditor = (): UseOpenChatImageInEditor => {
  const openPosterInEditor = (hashedId: string): void => {
    trackFakeDoorPostUsedIfNeeded();
    window.open(window.PMW.util.site_url(`posterbuilder/loadFromAiChatImage/${hashedId}`), '_blank');
    window.PMW.gtm.trackGA4CustomEvent(GA4EventName.AICHAT_OPEN_EDITOR, {[GA4EventParamName.TYPE]: AiChatOpenEditorType.EDIT_AS_IMAGE});
  };

  return {openPosterInEditor};
};
